module.exports = __webpack_public_path__ + "img/person-plus-fill.76cd761a.svg";